export default __webpack_public_path__ + "static/media/circular-bold.632caba3.woff";